import React from "react";
import PropTypes from 'prop-types';

const DayMatches = ({ dateStr, matches, equipes }) => {
    const date = new Date(`${dateStr}T00:00`);
    const formattedDate = date.toLocaleDateString('fr-FR', { 
        weekday: 'long', 
        month: 'long', 
        day: 'numeric',
        year: 'numeric'
    });

    return (
        <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4">
                <div className="h-0.5 flex-1 bg-gradient-to-r from-red-600 to-transparent"></div>
                <h3 className="text-lg font-bold text-white font-poppins whitespace-nowrap">
                    {formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1)}
                </h3>
                <div className="h-0.5 flex-1 bg-gradient-to-l from-red-600 to-transparent"></div>
            </div>

            <div className="flex flex-col gap-4 pl-4 border-l-2 border-red-600">
                {matches}
            </div>
        </div>
    );
};

DayMatches.propTypes = {
    dateStr: PropTypes.string.isRequired,
    matches: PropTypes.node.isRequired,
    equipes: PropTypes.array,
};

export default DayMatches;

